// @flow

import * as React from 'react';

import JobLogStore, { type JobPartial, type Job } from 'app/stores/JobLogStore';

import LegacyLoading from 'app/components/shared/LegacyLoading';

import JobLogOutputGroup from './Group';

type Props = {
  onChange: (changed: Job) => mixed,
  job: JobPartial,
  children: React.Node
};

type State = {
  log: Job
};

const getStateFromStore = (job) => ({ log: JobLogStore.load(job) });

export default class JobLogOutput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = getStateFromStore(props.job);
  }

  componentDidMount() {
    JobLogStore.addChangeListener(this.state.log.id, this.handleStoreChange);
  }

  componentWillUnmount() {
    JobLogStore.removeChangeListener(this.state.log.id, this.handleStoreChange);
  }

  handleStoreChange = () => {
    this.setState(getStateFromStore(this.props.job));
    this.props.onChange(this.state.log);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // TODO: This is a total hack, and probably shouldnt' be done here. If the
    // state of the job has changed, then reload the job log.
    if (this.props.job.state !== nextProps.job.state) {
      JobLogStore.refresh(this.state.log.id);
    }
  }

  render() {
    const { log } = this.state;

    const contentNode = (
      log.loaded
        ? (
          <table
            className={`JobLogOutputComponent__Table--${log.totalLines.toString().length}Column`}
          >
            {log.groups.map((group) => (
              <JobLogOutputGroup
                key={group.id}
                {...group}
              />
            ))}
          </table>
        )
        : (
          !this.props.job.startedAt
            ? <div className="JobLogOutputComponent__Loader" />
            : (
              <div className="JobLogOutputComponent__Loader">
                <LegacyLoading />
              </div>
            )
        )
    );

    return (
      <div className="JobLogOutputComponent">
        <div className="JobLogOutputComponent__Controls">
          {this.props.children}
        </div>
        <div className="JobLogOutputComponent__Body">
          {contentNode}
        </div>
      </div>
    );
  }
}
